module.exports = __webpack_public_path__ + "static/media/ATTORNEYS-single.ecc60b89.jpg";